import { type PropsWithChildren, type ReactNode } from "react";

import { cn } from "~/lib/utils";

type LayoutProps = PropsWithChildren<{
  header?: ReactNode;
  footer?: ReactNode;
  sidebar?: ReactNode;
  className?: string;
}>;

/**
 * Full-screen, edge-to-edge off-white shell for the collect operator page.
 * Left column = header + main (children) + footer; right column = sidebar.
 * The header and sidebar regions reserve their space even while empty — their
 * inner filter components are added in later steps.
 */
export const Layout = ({
  header,
  footer,
  sidebar,
  children,
  className
}: LayoutProps) => (
  <div
    className={cn(
      "flex h-screen overflow-hidden bg-interface-neutral-1",
      className
    )}
  >
    <section className="flex min-w-0 flex-1 flex-col">
      {/* Header placeholder: the filters toolbar goes here later. */}
      <header className="flex min-h-16 items-center px-5 pb-2 pt-4">
        {header}
      </header>

      <main className="flex min-h-0 flex-1 flex-col overflow-y-auto px-5 pb-3 pt-2">
        {children}
      </main>

      {footer}
    </section>

    {/* Sidebar placeholder: the filters go here later. */}
    <aside className="w-1/4 shrink-0 border-l border-interface-neutral-3 p-5">
      {sidebar}
    </aside>
  </div>
);
